// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--1b083";
export var container = "styles-module--container--430e6";
export var description = "styles-module--description--d1ab4";
export var header = "styles-module--header--71ff7";
export var section = "styles-module--section--ccd64";
export var title = "styles-module--title--e3939";
export var visible = "styles-module--visible--93822";